export { ConnectionTableFactory } from './connection-table-factory';
export { DoctorLinkTableFactory } from './doctor-link-table-factory';
export { PatientLinkTableFactory } from './patient-link-table-factory';
